var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"to":_vm.to,"loading":_vm.loading,"elevation":3}},[_c('div',{class:_vm.genClasses},[_c('div',{staticClass:"display-4 font-weight-medium ma-0"},[_vm._v(_vm._s(_vm.totalItems))]),(_vm.text != null)?_c('div',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }